define.alias("shared/modifiers/draggable", "calendar/modifiers/draggable");